import { post, refreshCsrfToken } from 'common/utils/xhr';
import { scrollToElement } from 'common/utils/scroll';

export default function createXhrForm(selector) {
    refreshCsrfToken();

    const container = document.querySelector(selector);
    container.addEventListener('submit', (e) => {
        e.preventDefault();

        const form = e.target;
        const formData = new FormData(form);
        const inputs = form.querySelectorAll('input');

        for (let input of inputs) {
            input.setAttribute('data-disabled', true);
            input.disabled = true;
        }

        const xhr = post(e.target.action, formData);
        xhr.end((err, { body }) => {
            if (!err) {
                container.querySelector('[data-form]').setAttribute('data-hidden', true);
                container.querySelector('[data-form-success]').removeAttribute('data-hidden');
                scrollToElement(container, 30, 0);
            } else {
                for (let input of inputs) {
                    input.removeAttribute('data-disabled', true);
                    input.disabled = false;
                }
            }
        });
    });
}



// WEBPACK FOOTER //
// ./js/marketing/components/xhrForm.js